import { StockItemData } from "@/types/stock";

export const getProductName = (stockItem: any): string => {
  if (!stockItem) return '';
  
  // Si nous avons directement les données
  if (stockItem.Race) {
    return stockItem.Race;
  }
  
  // Pour les données dans la propriété data
  if (stockItem.data) {
    if (stockItem.data.Race) {
      return stockItem.data.Race;
    }
    if (stockItem.data.name) {
      return stockItem.data.name;
    }
  }
  
  // Pour les données imbriquées dans data.data
  if (typeof stockItem === 'object' && stockItem.data && stockItem.data.data) {
    if (stockItem.data.data.Race) {
      return stockItem.data.data.Race;
    }
    if (stockItem.data.data.name) {
      return stockItem.data.data.name;
    }
  }

  return '';
};